'use client';

import React, { useCallback } from 'react';
import CheatAction from 'components/CheatAction';
import useZStore, { getUserNoteById } from 'utils/useZStore';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Example } from '@/types/Example';
import { updateUserNote } from '@/utils/update-user-note';

interface ReviewButtonProps {
  cheat: Example;
  className?: string;
}

const ReviewButton = (props: ReviewButtonProps) => {
  const { cheat, className } = props;
  const userNote = useZStore(getUserNoteById(cheat.id, true));
  const for_study = userNote?.for_study || false;

  // TO-DO: Optimize this, delegate the toggling of the field to the update
  // function
  const handleToggleHide = useCallback(
    async (_e: React.MouseEvent) => {
      const newUserNote = {
        ...userNote,
        for_study: !for_study,
      };

      updateUserNote(newUserNote);
    },
    [for_study, userNote],
  );

  return (
    <CheatAction
      onClick={handleToggleHide}
      className={className}
      tooltip={for_study ? 'Unmark for review' : 'Mark for review'}
    >
      <Clock
        size={18}
        aria-label={for_study ? 'Unmark for review' : 'Mark for review'}
        className={cn('transition-stroke fill-gray-50 duration-150 ease-out', {
          'fill-blue-100 stroke-blue-500': for_study,
        })}
      />
    </CheatAction>
  );
};

export default ReviewButton;
